/**
 * Created by jv on 2019-09-10 (12:40).
 */
const log = require("Sources/utils/logger")();

import utils from "Sources/utils/utils";
import GameView from "Sources/components/game/views/game-view";
import htmlView from "Views/partials/game/session-join.html";
import FormValidator from "Sources/components/form-validator";
import LanguageManager from "Sources/services/language-manager";
import GameSessionServices from "Sources/services/gamesession-services";

require("Styles/components/views/join-session.scss");

class SessionJoinView extends GameView
{
    constructor(options)
    {
        options.html = $(htmlView);
        super(options);

        this.path = "session-join";
        this.sessionId = options.sessionId;
        this.sessionTeamName = options.sessionTeamName;
    }

    render()
    {
        super.render();
        this._setUpEventListeners();

        this.onRender();
    }

    onRender()
    {
        super.onRender();

        this.formValidator = new FormValidator({
            selector: this.$element.find(".join-session-form"),
            validateOnChange: true,
            rules: {
                "session-id": {
                    required: true,
                    maxLength: 16,
                    validator: (value) =>
                    {
                        let regex = new RegExp("^[0-9]+$"); // only allow numeric (fontend check only)
                        return !utils.isNullOrEmpty(value) && value.trim() !== "" && regex.test(value);
                    }
                },
                "team-name": {
                    required: true,
                    maxLength: 20,

                    validator: (value) =>
                    {
                        let regex = new RegExp("^[a-zA-Z0-9\-_ ]+$"); // only allow alphanumeric, space, - and _ (keep in sync with GameSessionController.java)
                        return !utils.isNullOrEmpty(value) && value.trim() !== "" && regex.test(value);
                    },
                    // tooltip: LanguageManager.getValueForKey("serious_game.session.form.session_name.tooltip"),
                    // tooltipPlacement: "right"
                }
            }
        });

        this.formValidator.setValueForKey("session-id", this.sessionId);
        this.formValidator.setValueForKey("team-name", this.sessionTeamName);

        if (__DEVELOPMENT__)
        {
            $(window).on("keydown", e =>
            {
                if (e.ctrlKey)
                {
                    log.info(e.code);

                    if (e.code.startsWith("Digit") || e.code.startsWith("Numpad"))
                    {
                        let num = e.code.replace("Digit", "");
                        num = num.replace("Numpad", "");
                        this.formValidator.setValueForKey("session-id", "123456");
                        this.formValidator.setValueForKey("team-name", `Team${num}`);
                    }
                }
            })
        }
    }

    getFormSessionId()
    {
        if (utils.isNotNull(this.formValidator))
        {
            let formData = this.formValidator.getFormData();

            return utils.isNotNull(formData) ? formData["session-id"] : null;
        }

        return null;
    }

    setFormTeamName(teamName)
    {
        console.log("[SESSION-JOIN] Trying to set team name to :", teamName);
        if (utils.isNotNull(this.formValidator))
        {
            this.formValidator.setValueForKey("team-name", teamName);
        }

        this.sessionTeamName = teamName;
    }

    getFormTeamName()
    {
        if (utils.isNotNull(this.formValidator))
        {
            let formData = this.formValidator.getFormData();

            return utils.isNotNull(formData) ? formData["team-name"] : null;
        }

        return null;
    }

    showForm()
    {
        this.$element.find(".join-session-form-wrapper").removeClass("loading");
    }

    showLoadingState()
    {
        this.$element.find(".join-session-form-wrapper").addClass("loading");
    }

    setJoinButtonLoading(flag)
    {
        utils.setButtonLoading(this.$element.find(".join-session-btn"), flag);
    }

    handleError(error)
    {
        // Show name input field again when name error was thrown
        let nameInputErrors = [
            "E43987",
            "E88319"
        ];
        if (nameInputErrors.includes(error))
        {
            this.$element.find("#session-name-input-group").show();
        }
    }

    setFormError(errorMessage)
    {
        this.clearFormErrors();
        let $formError = $("<div class='form-error'></div>").text(errorMessage);
        this.$element.find(".form-errors").append($formError);
    }

    clearFormErrors()
    {
        this.$element.find(".form-errors").empty();
    }

    _setUpEventListeners()
    {
        this.$element.find(".join-session-btn").off("click").on("click", (e) =>
        {
            let $this = $(e.delegateTarget);

            this.clearFormErrors();
            let isValid = this.formValidator.validate();

            if (isValid)
            {
                this.setJoinButtonLoading(true);

                if (utils.isFunction(this.onJoinSession))
                {
                    this.onJoinSession.call(this, $this);
                }
            }
        });

        const $joinBtn = $(".join-session-btn");
        $joinBtn.prop("disabled", true);

        const $joinCheckbox = $("#session-join-checkbox");
        $joinCheckbox.prop("checked", false);

        $joinCheckbox.off("change").on("change", function(e)
        {
            $joinBtn.prop("disabled", !this.checked);
        });

        const $sessionIdInput = $("#session-id-input");
        $sessionIdInput.on("change", function(e)
        {
            GameSessionServices.getSessionLocale($(this).val()).then(locale =>
            {
                LanguageManager.changeLocale(locale);
            });
        });
    }
}

module.exports = SessionJoinView;



// WEBPACK FOOTER //
// ./app/js/components/game/views/session-join.js